function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M144.22,80.79A37.94,37.94,0,0,0,109,117.65a8.22,8.22,0,1,0,16.43.43h0a21.43,21.43,0,0,1,36.94-14.29c6.07,6.37,7.93,15.81,4.25,23.14-4.13,8.19-8.69,10.55-14.12,13.31-2.72,1.39-5.73,2.63-8.85,5.34a17.82,17.82,0,0,0-5.75,12.73v11.61a8.21,8.21,0,1,0,16.41.37v-12a1.91,1.91,0,0,0,0-.28.42.42,0,0,0,.15-.09,43.06,43.06,0,0,1,5.51-3.1c5.95-3,15.26-8.49,21.31-20.53,7.11-14.11,3.53-30.85-6.95-41.85A37.92,37.92,0,0,0,144.22,80.79Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M146.14,189.46h0a8.93,8.93,0,0,0-8.91,8.93h0a8.92,8.92,0,0,0,17.84,0h0A8.92,8.92,0,0,0,146.14,189.46Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M150,33.67A108.47,108.47,0,0,0,41.65,142,107.39,107.39,0,0,0,71.74,217l-4.85,38.8a9.42,9.42,0,0,0,9.35,10.58,9.54,9.54,0,0,0,4.22-1l38.8-19.41A108.36,108.36,0,1,0,150,33.67Zm0,199.69a91.34,91.34,0,0,1-28.79-4.63l-3.34-1.11L85.52,243.8l4.13-33.08-3.06-2.95A91.35,91.35,0,1,1,150,233.36Z"
});

var SvgFaqs = function SvgFaqs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaqs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faqs.07472098.svg";
export { ForwardRef as ReactComponent };